import { __read, __assign } from 'tslib';
import { useState } from 'react';
import { useUpdateEffect } from '../hooks/useUpdateEffect/index.js';

var defaults = {
    id: "",
    name: "",
    value: "",
};
var useButtonGroup = function (_a) {
    var _b = _a.defaultSelected, defaultSelected = _b === void 0 ? "" : _b, onChange = _a.onChange;
    var _c = __read(useState(__assign(__assign({}, defaults), { id: defaultSelected })), 2), selected = _c[0], setSelected = _c[1];
    var handleOnClick = function (id, onClickProp) { return function (evt) {
        setSelected({
            id: id,
            name: evt.currentTarget.name,
            value: evt.currentTarget.value,
        });
        // call external onClick
        onClickProp === null || onClickProp === void 0 ? void 0 : onClickProp(evt);
    }; };
    useUpdateEffect(function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(selected);
    }, [selected]);
    return { selected: selected, handleOnClick: handleOnClick, setSelected: setSelected };
};

export { useButtonGroup };
//# sourceMappingURL=useButtonGroup.js.map
